








































import { Component, Vue } from 'vue-property-decorator';
import ChangedDocumentStatusNeedSignatureViewModel
  from '@/vue-app/view-models/allianz-dashboard/allianz-actions/changed-document-status/changed-document-status-need-signature-view-model';

@Component({ name: 'ChangedDocumentStatusNeedSignature' })
export default class ChangedDocumentStatusNeedSignature extends Vue {
  need_signature_view_model = Vue.observable(
    new ChangedDocumentStatusNeedSignatureViewModel(),
  );

  async mounted() {
    await this.need_signature_view_model.initialize();
  }

  closeModal() {
    this.$emit('closeDialog');
  }
}
